/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiMembershipProduct } from './MembershipProduct';

export interface OfferRequest {

    /**
     * Offer UUID
     */
    uuid?: string;

    /**
     * Name of the offer
     */
    name?: string;

    /**
     * Title of the offer
     */
    title?: string;

    /**
     * Benefits of the offer
     */
    benefits?: string;

    /**
     * Number of trial days offered. Zero for no free trial
     */
    trial_days?: Number;

    /**
     * Product price in dollars
     */
    dollar_price?: number;

    /**
     * Alternate product price in dollars
     */
    alternate_dollar_price?: number;

    /**
     * Introductory price in cents
     */
    price?: number;

    /**
     * Number of periods benefiting from the introdoctory pricing
     */
    introductory_periods?: number;

    /**
     * Period of the offer
     */
    period?: string;

    /**
     * Publish status of the offer
     */
    published?: boolean;

    /**
     * Join call to action
     */
    action_text?: string;

    membership_product?: ApiMembershipProduct;

    alternate_membership_product?: ApiMembershipProduct;

    /**
     * Kind of offer
     */
    kind?: string;

    /**
     * Whether this offer should be shown above the fold
     */
    above_the_fold?: boolean;

    /**
     * True if this offer is subsidized
     */
    subsidized?: boolean;

    /**
     * Number of sponsorships this offer unlocks
     */
    sponsorship_count?: number;

    /**
     * True if this offer should be highlighted
     */
    highlighted?: boolean;

    /**
     * When highlighted is true, the text that should be displayed on the offer
     */
    highlight_text?: string;

    /**
     * True when this offer has sponsorships available
     */
    sponsorship_available?: boolean;

    membership_level?: ApiMembershipProduct;

}

@Model('Offer')
export class ApiOffer extends BaseModel implements OfferRequest {

    /**
     * Offer UUID
     */
    
    
    uuid: string;

    /**
     * Name of the offer
     */
    
    
    name: string;

    /**
     * Title of the offer
     */
    
    
    title: string;

    /**
     * Benefits of the offer
     */
    
    
    benefits: string;

    /**
     * Number of trial days offered. Zero for no free trial
     */
    
    
    trial_days: Number;

    /**
     * Product price in dollars
     */
    
    
    dollar_price: number;

    /**
     * Alternate product price in dollars
     */
    
    
    alternate_dollar_price: number;

    /**
     * Introductory price in cents
     */
    
    
    price: number;

    /**
     * Number of periods benefiting from the introdoctory pricing
     */
    
    
    introductory_periods: number;

    /**
     * Period of the offer
     */
    
    
    period: string;

    /**
     * Publish status of the offer
     */
    
    
    published: boolean;

    /**
     * Join call to action
     */
    
    
    action_text: string;

    @Type('ApiMembershipProduct')
    @Expand()
    membership_product: ApiMembershipProduct;

    @Type('ApiMembershipProduct')
    @Expand()
    alternate_membership_product: ApiMembershipProduct;

    /**
     * Kind of offer
     */
    
    
    kind: string;

    /**
     * Whether this offer should be shown above the fold
     */
    
    
    above_the_fold: boolean;

    /**
     * True if this offer is subsidized
     */
    
    
    subsidized: boolean;

    /**
     * Number of sponsorships this offer unlocks
     */
    
    
    sponsorship_count: number;

    /**
     * True if this offer should be highlighted
     */
    
    
    highlighted: boolean;

    /**
     * When highlighted is true, the text that should be displayed on the offer
     */
    
    
    highlight_text: string;

    /**
     * True when this offer has sponsorships available
     */
    
    
    sponsorship_available: boolean;

    @Type('ApiMembershipProduct')
    @Expand()
    membership_level: ApiMembershipProduct;

}
